/**
 * Collision detection constants
 * Centralizes all collision-related configuration
 */

import { FEET_TO_METERS } from './units'

// Proximity-based collision detection
export const COLLISION_CHECK_RADIUS_FEET = 150
export const COLLISION_CHECK_RADIUS_METERS = COLLISION_CHECK_RADIUS_FEET * FEET_TO_METERS

// Performance monitoring
export const PERFORMANCE_REPORT_INTERVAL = 10000 // Report every 10 seconds
export const MIN_COLLISION_CHECK_INTERVAL = 50 // Minimum 50ms between collision checks
export const MAX_COLLISION_CHECKS_PER_SECOND = 20 // Maximum collision checks per second

// Collision detection sampling
export const VERTEX_SAMPLE_RATE = 15 // Use every 15th vertex for convex hull
export const VERTEX_SAMPLE_RATE_COMPONENTS = 20 // Slightly higher sampling for components
export const VERTEX_SAMPLE_RATE_MINOR = 40 // Lower sampling for minor components

// Logging
export const LOG_INTERVAL = 5000 // 5 seconds between identical log messages

// Collision volume scaling
export const SCALED_BOUNDING_BOX_FACTOR = 0.85 // 85% of original size to reduce false positives

// Component mesh thresholds
export const MAJOR_MESH_VERTEX_THRESHOLD = 50000
export const MINOR_MESH_VERTEX_THRESHOLD = 5000

// Debug logging configuration
export const ENABLE_COLLISION_DEBUG = true // Toggle collision debug logging globally
export const SHOW_DEBUG_PANEL = import.meta.env.DEV // Show debug panel in development
export const DEBUG_VERBOSITY_LEVEL = 'DETAILED' as const // 'BASIC' | 'DETAILED' | 'VERBOSE'

// Debug flags for specific collision aspects
export const DEBUG_OBB_CREATION = true // Log OBB/hull creation details
export const DEBUG_COMPONENT_CLASSIFICATION = true // Log mesh classification (major/minor)
export const DEBUG_OBB_INTERSECTIONS = true // Log OBB intersection tests
export const DEBUG_BVH_CHECKS = true // Log BVH narrow phase results
export const DEBUG_WALL_COLLISIONS = true // Log wall collision details
export const DEBUG_CONVEX_HULL_FAILURES = true // Log when convex hull generation fails

// Debug thresholds
export const DEBUG_LOW_EFFICIENCY_THRESHOLD = 0.5 // Warn if hull efficiency < 50%
export const DEBUG_CLOSE_PROXIMITY_THRESHOLD = 2.0 // Warn if objects within 2m but not colliding

// Safety margin defaults (in feet) - can be overridden per location
export const DEFAULT_WINGTIP_CLEARANCE_FT = 2.5
export const DEFAULT_TAIL_CLEARANCE_FT = 1.5
export const DEFAULT_DOOR_CLEARANCE_FT = 1.0
export const DEFAULT_COLLISION_BUFFER_FT = 0.5
